import projectsActions from './actions';

export default {
  ...projectsActions
};
